import React from 'react'
import {
    Image, NavBar, Toast, FloatingBubble, Popup, Grid, CapsuleTabs, Form, Input, JumboTabs
    , Selector, List, Picker, TextArea, Modal, Button
} from 'antd-mobile-v5';
import { LeftOutline,MessageFill } from 'antd-mobile-icons'
import { useNavigate, useParams, useLocation } from 'react-router-dom';

import {
    GetPlanets,GetNNProductsByTypeId,GetJsApiPay,PostNNShoppingOrders,SensitiveWordsVerify
} from '../../service/service';
import { environment } from '../../service/baseUrl';

import '../../assets/font/font.css'
import '../DriftingDown/index.css'

const withNavigate = (WrappedComponent) => {
    return (props) => {
        const params = useParams();
        const navigate = useNavigate();
        const location = useLocation();
        return <WrappedComponent {...props} params={params} navigate={navigate} location={location} />;
    };
};

class Index extends React.Component {
    formRef = React.createRef();

    constructor(props) {
        super(props);

        this.state = {
            visible6: false,
            visible5: false,
            visible4: false,
            visible: false,
            visibleMsg: "",

            myShopping: [],
            shopping: [],

            hdShopping: [],
            kmdShopping: [],
            
            planets: [],
            planetName: "请选择",
            planetId: null,
            hedengs: [],
            HDInfo: {},
            kongmingdengs: [],
            KMDInfo: {},
            remark: "",
            
            productActiveKey: null,
            productInfoPrice: 0,
            userInfo: {},

            IsPlanet: true,
        };
    }

    componentDidMount() {
        var that = this;

        var user = localStorage.getItem("user");
        if (user == null || user == undefined) {

        } else {
            var user = JSON.parse(user);
            this.setState({
                userInfo: user
            })
        
            var data = {
                MaxResultCount: 999,
                PayState: 2
            };
            PostNNShoppingOrders(data).then(res => {
                if (res.success) {
                    var myList = [];
                    var hdShopping = [];
                    var kmdShopping = [];
                    res.result.items.map(item => {
                        if (item.productImgUrl != null) {
                            var name = item.productImgUrl.split('/').pop()
                            item.productImgUrl = environment.apiEndpoint + "/NNFiles/Img/" + name;
                        }

                        if (item.productTypeId == 497) {
                            if (new Date(item.endDate) > new Date()) {
                                hdShopping.push(item)
                            }
                            if (item.openId == user.openId) {
                                myList.push(item)
                            }
                        }

                        if (item.productTypeId == 498) {
                            if (new Date(item.endDate) > new Date()) {
                                kmdShopping.push(item)
                            }
                            if (item.openId == user.openId) {
                                myList.push(item)
                            }
                        }
                    })
                    that.setState({
                        myShopping: myList,
                        shopping: res.result.items,
                        hdShopping: hdShopping,
                        kmdShopping: kmdShopping,
                    })

                    that.initIntervalId1(hdShopping)
                    // that.initIntervalId2(kmdShopping)

                }
            })
        }


        GetPlanets().then(res => {
            if (res.success) {
                var planets = [];
                res.result.map(item => {
                    planets.push({
                        label: item.name, value: item.id
                    })
                })
                var IsPlanet = true;
                if (planets.length == 0) {
                    IsPlanet = false;
                } else {
                    this.setState({
                        planetId: planets[0].value,
                        planetName: planets[0].label,
                    })
                }
                this.setState({
                    planets: planets,
                    IsPlanet
                });
            }
        })

        GetNNProductsByTypeId(497).then(res => {
            if (res.success) {
                this.setState({
                    hedengs: res.result,
                    HDInfo: res.result.length == 0 ? {} : res.result[0],
                });
            }
        })

        GetNNProductsByTypeId(498).then(res => {
            if (res.success) {
                this.setState({
                    kongmingdengs: res.result,
                    KMDInfo: res.result.length == 0 ? {} : res.result[0],
                });
            }
        })
    }

    componentWillUnmount() {
        clearInterval(this.intervalId1);
        clearInterval(this.intervalId2);
    }

    initIntervalId1(hdShopping) {
        let currentIndex = 0;
        const itemCount = hdShopping.length;
        if (itemCount <= 0) {
            return;
        }

        // Clear any existing interval to prevent multiple intervals running
        if (this.intervalId1) {
            clearInterval(this.intervalId1);
        }

        this.intervalId1 = setInterval(() => {
            // Execute the function for the current item
            this.createSnowflake2(hdShopping[currentIndex].productImgUrl, hdShopping[currentIndex].remark);

            // Move to the next item
            currentIndex++;

            // If we've reached the end of the array, reset to the beginning
            if (currentIndex >= itemCount) {
                currentIndex = 0;
            }
        }, 9000);
    }

    initIntervalId2(kmdShopping) {
        let currentIndex = 0;
        const itemCount = kmdShopping.length;
        if (itemCount <= 0) {
            return;
        }

        if (this.intervalId2) {
            clearInterval(this.intervalId2);
        }

        this.intervalId2 = setInterval(() => {
            // Execute the function for the current item
            this.createSnowflake(kmdShopping[currentIndex].productImgUrl, kmdShopping[currentIndex].remark);

            // Move to the next item
            currentIndex++;

            // If we've reached the end of the array, reset to the beginning
            if (currentIndex >= itemCount) {
                currentIndex = 0;
            }
        }, 4000);


        // this.intervalId2 = setInterval(() => {
        //     this.createSnowflake();
        // }, 2000);
    }

    //孔明灯
    createSnowflake = (url, text) => {
        var that = this;
        const home = document.getElementById('bj');
        const snowflake = document.createElement('div');
        snowflake.classList.add('kongmingdeng');
    
        // 根据 isLeft 决定起始位置
        const currentIsLeft = this.state.isLeft;
        if (currentIsLeft) {
            snowflake.style.left = '60px'; // 从左边开始
        } else {
            snowflake.style.right = '60px'; // 从右边开始
        }
    
        // 切换 isLeft 的值
        this.setState((prevState) => ({
            isLeft: !prevState.isLeft,
        }));
    
        // 添加孔明灯图片
        // snowflake.innerHTML = '<img src="https://api.weibinyi.com/images/niannian/4/5-12.png" width="100%" />';
        snowflake.innerHTML = '<img src="' + url + '" width="70px" />';
        if (home == null) {
            return;
        }
        home.appendChild(snowflake);
    
        // 创建弹框元素 - 现在作为孔明灯的子元素
        const tooltip = document.createElement('div');
        tooltip.className = 'kongming-tooltip';
        // tooltip.innerHTML = '<div class="tooltip-content">这里是弹框内容</div>';
        tooltip.innerHTML = '<div class="tooltip-content">' + text + '</div>';
        tooltip.style.display = 'none';
        snowflake.appendChild(tooltip); // 改为添加到孔明灯元素内
    
        // 点击事件
        snowflake.addEventListener('click', function() {
            // 切换显示/隐藏
            // tooltip.style.display = tooltip.style.display === 'none' ? 'block' : 'none';
            that.setState({
                visible: true,
                visibleMsg: text,
            })
        });
    
        // 动画结束后移除孔明灯
        snowflake.addEventListener('animationend', () => {
            home.removeChild(snowflake);
        });
    }

    //河灯
    createSnowflake2 = (url, text) => {
        var that = this;
        const home = document.getElementById('bj');
        const snowflake = document.createElement('div');
        snowflake.classList.add('hedeng');
        snowflake.style.left = '20%';
        snowflake.style.fontSize = 30 + 'px';

        // snowflake.innerHTML = '<img src="https://api.weibinyi.com/images/niannian/4/5-14.png" width="80%" />';
        snowflake.innerHTML = '<img src="' + url + '" width="100px" />';
        if (home == null) {
            return;
        }

        const tooltip = document.createElement('div');
        tooltip.className = 'tooltip';
        // tooltip.textContent = "这里是提示内容这里是提示内容这里是提示内容这里是提示内容这里是提示内容";
        tooltip.textContent = text;
        tooltip.style.display = 'none';
        snowflake.appendChild(tooltip);

        home.appendChild(snowflake);

        snowflake.addEventListener('click', function () {
            // tooltip.style.display = tooltip.style.display === 'none' ? 'block' : 'none';
            that.setState({
                visible: true,
                visibleMsg: text,
            })
        });

        // Remove snowflake from DOM after it falls
        snowflake.addEventListener('animationend', () => {
            home.removeChild(snowflake);
        });

    }



    submitForm = (productId) => {
        if (this.state.productActiveKey == null || this.state.productActiveKey == "null") {
            Toast.show({
                content: "请选择展示时长！",
                position: 'top',
            });
            return;
        }
        if (this.state.planetId == null) {
            Toast.show({
                content: "请选择关联星球！",
                position: 'top',
            });
            return;
        }
        if (this.state.remark == null || this.state.remark.trim() == "") {
            Toast.show({
                content: "请输入许愿内容！",
                position: 'top',
            });
            return;
        }
        var data = {
            ProductId: productId,
            ProductPriceId: this.state.productActiveKey,
            PayType: 1,
            PlanetId: this.state.planetId,
            Remark: this.state.remark,
        };
        
        var that = this;

        var Contents = [];
        Contents.push(data.Remark);
        var model = {
            Contents: Contents
        };
        SensitiveWordsVerify(model).then(res=>{
            if (res.result) {
                GetJsApiPay(data).then(res => {
                    if (res.success) {
                        that.jsApiCall(res.result);
                    } else {
                        Toast.info("内部错误！", 1);
                    }
                })
            } else {
                Toast.show({
                    icon: 'fail',
                    content: '表单数据中包含违规内容，请修改后重试！',
                });
            }
        })
        
    }

    jsApiCall(wxJsApiParam) {
        var that = this;

        window.WeixinJSBridge.invoke(
            'getBrandWCPayRequest',
            JSON.parse(wxJsApiParam),//josn串
            function (res) {
                switch (res.err_msg) {
                    case 'get_brand_wcpay_request:cancel':

                        Toast.info("用户取消支付!", 1);
                        break;
                    case 'get_brand_wcpay_request:fail':

                        Toast.info("支付失败！（" + res.err_desc + "）", 1);
                        break;
                    case 'get_brand_wcpay_request:ok':

                        Toast.show({
                            icon: 'success',
                            content: '购买成功！',
                        })

                        that.setState({
                            visible6: false,
                            visible5: false,
                            visible4: false,
                        })

                        setTimeout(() => {
                            window.location.reload();
                        }, 1000);

                        break;
                    default:
                        Toast.info(JSON.stringify(res), 1);
                        break;
                }
            }
        );
    }
    


    render() {



        return (
            <div id="bj" className="bj" style={{ height: "100%", width: "100%" }}>
                <NavBar back='' backArrow={<LeftOutline color='#fff' />} onBack={() => {
                    this.props.navigate('/posts', { replace: true }); // 传递状态
                }}>
                    {/* <span style={{ color: "#fff" }}>寄思念</span> */}
                </NavBar>


                
                <FloatingBubble
                    axis='xy'
                    magnetic='x'
                    style={{
                        '--initial-position-bottom': '20%',
                        '--initial-position-right': '10px',
                        '--edge-distance': '10px',
                        '--background': '#ffffff00',
                        '--size':'80px'
                    }}
                    onClick={() => {
                        var productActiveKey = null;
                        var productInfoPrice = 0;
                        if (this.state.HDInfo.productPriceDtos != null
                            && this.state.HDInfo.productPriceDtos.length > 0) {
                            productActiveKey = this.state.HDInfo.productPriceDtos[0].id
                            productInfoPrice = this.state.HDInfo.productPriceDtos[0].price
                        }
                        this.setState({
                            visible4: true,
                            // planetName: "请选择",
                            remark: "",
                            productInfoPrice: 0,
                            // planetId: null,
                            productActiveKey: productActiveKey + "",
                            productInfoPrice: productInfoPrice,
                        })
                    }}
                >
                    <Image src={"https://api.weibinyi.com/images/niannian/4/4-08.png"} fit='fill' width={55} height={60} />
                </FloatingBubble>
                <Popup
                    visible={this.state.visible4}
                    mask={true}
                    onMaskClick={() => {
                        this.setState({
                            visible4: false,
                        })
                    }}
                    bodyStyle={{
                        borderTopLeftRadius: '25px',
                        borderTopRightRadius: '25px',
                        minHeight: '40vh',
                    }}
                >
                    <Grid columns={4} gap={8}>

                        <Grid.Item span={4}>
                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                <Image style={{ marginTop: "-40px" }}
                                    src={"https://api.weibinyi.com/images/niannian/4/5-14.png"} fit='fill' width={80} height={90} />
                                <div style={{ fontWeight: "600", fontSize: "14px", marginTop: "-10px", marginBottom: "10px" }}>
                                    河灯许愿
                                </div>
                            </div>
                        </Grid.Item>
                        <Grid.Item span={1}>
                            <div style={{ textAlign: "center", lineHeight: "25px", fontSize: "15px" }}>
                                许愿内容
                            </div>
                        </Grid.Item>
                        <Grid.Item span={3}>
                            <TextArea
                                placeholder='请输入许愿内容'
                                value={this.state.remark}
                                onChange={(val) => {
                                    this.setState({ remark: val });
                                }}
                                maxLength={30}
                                rows={2}
                                style={{
                                    '--font-size': '16px',
                                    '--border-radius': '12px',
                                    '--color': '#333',
                                    '--placeholder-color': '#999',
                                    '--border': '1px solid #e8e8e8',
                                    '--background-color': '#f9f9f9',
                                    '--padding-left': '12px',
                                    '--padding-right': '12px',
                                    '--count-color': '#999',
                                    '--count-font-size': '14px',
                                    '--active-border': '1px solid #FF6B81', // 粉色边框，符合河灯主题
                                    '--padding-top': '12px',
                                    '--padding-bottom': '12px',
                                }}
                            />
                        </Grid.Item>
                        <Grid.Item span={4}>
                            <div style={{ borderBottom: "solid 2px #e5e5e5", width: "96%", marginLeft: "2%" }}></div>
                        </Grid.Item>
                        <Grid.Item span={1}>
                            <div style={{ textAlign: "center", lineHeight: "70px", fontSize: "15px" }}>
                                展示时长
                            </div>
                        </Grid.Item>
                        <Grid.Item span={3}>
                            <JumboTabs activeKey={this.state.productActiveKey} onChange={(key) => {
                                if (this.state.KMDInfo == null || this.state.KMDInfo.productPriceDtos == null) {
                                    return;
                                }
                                var item = this.state.HDInfo.productPriceDtos.filter(x => x.id == key);
                                this.setState({
                                    productActiveKey: key,
                                    productInfoPrice: item.length == 0 ? 0 : item[0].price
                                });
                            }}>
                                {
                                    this.state.HDInfo.productPriceDtos == null ? null :
                                        this.state.HDInfo.productPriceDtos.map(item => {
                                            return (<JumboTabs.Tab title={item.typeName}
                                                description={'￥' + (item.price || 0).toFixed(1)}
                                                key={item.id}>
                                            </JumboTabs.Tab>)
                                        })
                                }
                            </JumboTabs>
                        </Grid.Item>
                        <Grid.Item span={4}>
                            <div style={{ borderBottom: "solid 2px #e5e5e5", width: "96%", marginLeft: "2%" }}></div>
                        </Grid.Item>

                        <Grid.Item span={4}>
                            {
                                this.state.IsPlanet ?
                                    <List header='' style={{
                                        width: "96%", marginLeft: "2%", marginTop: "-5px", marginBottom: "-9px",
                                        borderBottom: "2px solid rgb(229 229 229 / 0%)"
                                    }}>
                                        <List.Item extra={this.state.planetName} onClick={async () => {
                                            const value = await Picker.prompt({
                                                columns: [this.state.planets]
                                            })

                                            var items = this.state.planets.filter(x => x.value == value);
                                            this.setState({
                                                planetName: items[0].label,
                                                planetId: items[0].value,
                                            })
                                        }}>
                                            <span style={{ fontSize: "15px" }}>
                                                关联星球
                                    </span>
                                        </List.Item>
                                    </List> :
                                    <div style={{
                                        paddingTop: "2px", marginLeft: "10px", marginRight: "10px", paddingBottom: "10px",
                                        borderBottom: "solid 1px #ececec", textAlign: 'center', lineHeight: "35px", fontSize: "17px"
                                    }}>
                                        请先关注先人空间
                    </div>
                            }
                        </Grid.Item>

                        <Grid.Item span={4}>
                            <div style={{
                                backgroundImage: "url('https://api.weibinyi.com/images/niannian/4/5-16.png')", backgroundRepeat: "no-repeat"
                                , backgroundSize: "100% 100%", height: "38px", width: "94%", marginLeft: "3%", marginTop: "5px"
                            }}>
                                <Grid columns={4} gap={8}>
                                    <Grid.Item span={3}>
                                        <span style={{ fontSize: "13px", marginLeft: "25px" }}>合计</span>
                                        <span style={{ fontSize: "24px", fontWeight: "600", marginLeft: "8px" }}>
                                            ￥{(this.state.productInfoPrice || 0).toFixed(1)}
                                        </span>
                                    </Grid.Item>
                                    <Grid.Item span={1}>
                                        <div style={{
                                            backgroundImage: "url('https://api.weibinyi.com/images/niannian/4/5-17.png')"
                                            , backgroundRepeat: "no-repeat", backgroundSize: "100% 100%", height: "38px"
                                            , lineHeight: "38px", textAlign: "center", fontSize: "15px", color: "#fff"
                                        }} onClick={()=>{
                                            this.submitForm(this.state.HDInfo.id);
                                        }}>
                                            购 买
                                </div>
                                    </Grid.Item>
                                </Grid>
                            </div>
                        </Grid.Item>

                    </Grid>
                    <div style={{ marginTop: "25px" }}></div>
                </Popup>


                {/* <FloatingBubble
                    axis='xy'
                    magnetic='x'
                    style={{
                        '--initial-position-bottom': '20%',
                        '--initial-position-right': '10px',
                        '--edge-distance': '10px',
                        '--background': '#ffffff00',
                        '--size':'80px'
                    }}
                    onClick={() => {
                        var productActiveKey = null;
                        var productInfoPrice = 0;
                        if (this.state.KMDInfo.productPriceDtos != null
                            && this.state.KMDInfo.productPriceDtos.length > 0) {
                            productActiveKey = this.state.KMDInfo.productPriceDtos[0].id
                            productInfoPrice = this.state.KMDInfo.productPriceDtos[0].price
                        }
                        this.setState({
                            visible5: true,
                            remark: "",
                            productInfoPrice: 0,
                            productActiveKey: productActiveKey + "",
                            productInfoPrice: productInfoPrice,
                        })
                    }}
                >
                    <Image src={"https://api.weibinyi.com/images/niannian/4/4-09.png"} fit='fill' width={55} height={60} />
                </FloatingBubble> */}
                <Popup
                    visible={this.state.visible5}
                    mask={true}
                    onMaskClick={() => {
                        this.setState({
                            visible5: false
                        })
                    }}
                    bodyStyle={{
                        borderTopLeftRadius: '25px',
                        borderTopRightRadius: '25px',
                        minHeight: '40vh',
                        zIndex:"99999"
                    }}
                >
                    <Grid columns={4} gap={8}>

                        <Grid.Item span={4}>
                            <div style={{ display: "flex", justifyContent: "center" }}>
                                <Image style={{ marginTop: "-35px" }}
                                    src={"https://api.weibinyi.com/images/niannian/4/5-12.png"} fit='fill' width={80} height={90} />
                                <span style={{ marginTop: "10px", fontWeight: "600", fontSize: "14px" }}>
                                    孔明灯许愿
                                </span>
                            </div>
                        </Grid.Item>
                        <Grid.Item span={1}>
                            <div style={{ textAlign: "center", lineHeight: "25px", fontSize: "15px" }}>
                                许愿内容
                            </div>
                        </Grid.Item>
                        <Grid.Item span={3}>
                            <TextArea
                                placeholder='请输入许愿内容'
                                value={this.state.remark}
                                onChange={(val) => {
                                    this.setState({ remark: val });
                                }}
                                maxLength={30}
                                rows={2}
                                style={{
                                    '--font-size': '16px',
                                    '--border-radius': '12px',
                                    '--color': '#333',
                                    '--placeholder-color': '#999',
                                    '--border': '1px solid #e8e8e8',
                                    '--background-color': '#f9f9f9',
                                    '--padding-left': '12px',
                                    '--padding-right': '12px',
                                    '--count-color': '#999',
                                    '--count-font-size': '14px',
                                    '--active-border': '1px solid #FF6B81', // 粉色边框，符合河灯主题
                                    '--padding-top': '12px',
                                    '--padding-bottom': '12px',
                                }}
                            />
                        </Grid.Item>
                        <Grid.Item span={4}>
                            <div style={{ borderBottom: "solid 2px #e5e5e5", width: "96%", marginLeft: "2%" }}></div>
                        </Grid.Item>
                        <Grid.Item span={1}>
                            <div style={{ textAlign: "center", lineHeight: "70px", fontSize: "15px" }}>
                                展示时长
                            </div>
                        </Grid.Item>
                        <Grid.Item span={3}>
                            <JumboTabs activeKey={this.state.productActiveKey} onChange={(key) => {
                                if (this.state.KMDInfo == null || this.state.KMDInfo.productPriceDtos == null) {
                                    return;
                                }
                                var item = this.state.KMDInfo.productPriceDtos.filter(x => x.id == key);
                                this.setState({
                                    productActiveKey: key,
                                    productInfoPrice: item.length == 0 ? 0 : item[0].price
                                });
                            }}>
                                {
                                    this.state.KMDInfo.productPriceDtos == null ? null :
                                        this.state.KMDInfo.productPriceDtos.map(item => {
                                            return (<JumboTabs.Tab title={item.typeName}
                                                description={'￥' + (item.price || 0).toFixed(1)}
                                                key={item.id}>
                                            </JumboTabs.Tab>)
                                        })
                                }
                            </JumboTabs>
                        </Grid.Item>
                        <Grid.Item span={4}>
                            <div style={{ borderBottom: "solid 2px #e5e5e5", width: "96%", marginLeft: "2%" }}></div>
                        </Grid.Item>
                        <Grid.Item span={4}>
                            {
                                this.state.IsPlanet ?
                                    <List header='' style={{
                                        width: "96%", marginLeft: "2%", marginTop: "-5px", marginBottom: "-9px",
                                        borderBottom: "2px solid rgb(229 229 229 / 0%)"
                                    }}>
                                        <List.Item extra={this.state.planetName} onClick={async () => {
                                            const value = await Picker.prompt({
                                                columns: [this.state.planets]
                                            })

                                            var items = this.state.planets.filter(x => x.value == value);
                                            this.setState({
                                                planetName: items[0].label,
                                                planetId: items[0].value,
                                            })
                                        }}>
                                            <span style={{ fontSize: "15px" }}>
                                                关联星球
                                    </span>
                                        </List.Item>
                                    </List> :
                                    <div style={{
                                        paddingTop: "2px", marginLeft: "10px", marginRight: "10px", paddingBottom: "10px",
                                        borderBottom: "solid 1px #ececec", textAlign: 'center', lineHeight: "35px", fontSize: "17px"
                                    }}>
                                        请先关注先人空间
                    </div>
                            }
                        </Grid.Item>
                        <Grid.Item span={4}>
                            <div style={{
                                backgroundImage: "url('https://api.weibinyi.com/images/niannian/4/5-16.png')", backgroundRepeat: "no-repeat"
                                , backgroundSize: "100% 100%", height: "38px", width: "94%", marginLeft: "3%", marginTop: "5px"
                            }}>
                                <Grid columns={4} gap={8}>
                                    <Grid.Item span={3}>
                                        <span style={{ fontSize: "13px", marginLeft: "25px" }}>合计</span>
                                        <span style={{ fontSize: "24px", fontWeight: "600", marginLeft: "8px" }}>
                                            ￥{(this.state.productInfoPrice || 0).toFixed(1)}
                                        </span>
                                    </Grid.Item>
                                    <Grid.Item span={1}>
                                        <div style={{
                                            backgroundImage: "url('https://api.weibinyi.com/images/niannian/4/5-17.png')"
                                            , backgroundRepeat: "no-repeat", backgroundSize: "100% 100%", height: "38px"
                                            , lineHeight: "38px", textAlign: "center", fontSize: "15px", color: "#fff"
                                        }} onClick={()=>{
                                            this.submitForm(this.state.KMDInfo.id);
                                        }}>
                                            购 买
                                </div>
                                    </Grid.Item>
                                </Grid>
                            </div>
                        </Grid.Item>

                    </Grid>
                    <div style={{ marginTop: "25px" }}></div>
                </Popup>


                <FloatingBubble
                    axis='xy'
                    magnetic='x'
                    style={{
                        '--initial-position-bottom': '9%',
                        '--initial-position-right': '10px',
                        '--edge-distance': '10px',
                        '--background': '#ffffff00',
                        '--size':'80px'
                    }}
                    onClick={()=>{
                        this.setState({
                            visible6:true
                        })
                    }}
                >
                    <Image src={"https://api.weibinyi.com/images/niannian/4/4-10.png"} fit='fill' width={55} height={60} />
                </FloatingBubble>
                <Popup
                    visible={this.state.visible6}
                    mask={true}
                    onMaskClick={() => {
                        this.setState({
                            visible6: false
                        })
                    }}
                    bodyStyle={{
                        borderTopLeftRadius: '25px',
                        borderTopRightRadius: '25px',
                        height: '45vh',
                    }}
                >
                    <Grid columns={4} gap={8}>
                        <Grid.Item span={4}>
                            <div style={{ textAlign: "center", marginTop: "12px" }}>
                                <div style={{ fontWeight: "600", fontSize: "14px" }}>
                                    我的许愿
                                </div>
                            </div>
                        </Grid.Item>
                    </Grid>

                    <div style={{
                        padding: '12px', paddingBottom: "20px", paddingTop: "0px"
                        , height: '45vh', overflowY: "scroll", paddingBottom: "10%"
                    }}>
                        <List header="" mode='card'>
                            {this.state.myShopping.map((item) => (
                                <List.Item
                                    key={item.id}
                                    prefix={
                                        <div style={{
                                            width: 60,
                                            height: 60,
                                            // backgroundColor: '#f5f5f5',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            borderRadius: 4,
                                            overflow: 'hidden'
                                        }}>
                                            {item.productTypeId == 498 ? (
                                                <Image src={"https://api.weibinyi.com/NNFiles/Img/20250430083437.png"}
                                                    width={60} height={60} fit='cover' />
                                            ) : (
                                                    <Image src={"http://47.103.153.128:9001/NNFiles/Img/20250430083550.png"}
                                                        width={60} height={60} fit='cover' />
                                                )}
                                        </div>
                                    }
                                    description={
                                        <div style={{ color: '#999', fontSize: 12 }}>
                                            {item.yyyymmdd} · 上海
                                        </div>
                                    }
                                >
                                    <div style={{
                                        fontSize: 15,
                                        lineHeight: 1.5,
                                        color: '#333',
                                        whiteSpace: 'pre-wrap'
                                    }}>
                                        {item.remark}
                                    </div>
                                </List.Item>
                            ))}
                        </List>
                    </div>
                </Popup>



                {
                    this.state.visible ?
                        <div
                            style={{
                                position: 'fixed',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                display: 'flex',
                                justifyContent: 'center',
                                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                // 关键修改：取消垂直居中，改为顶部对齐后再向下偏移
                                alignItems: 'flex-start',
                                paddingTop: '45%', // 距离顶部的距离，可根据需要调整
                                zIndex: 1000,
                            }}
                            onClick={() => {
                                this.setState({ visible: false });
                            }}
                        >
                            <style jsx global>{`
                @keyframes cardRotateSlow {
                    from { 
                        transform: rotateY(-90deg); 
                        opacity: 0;
                    }
                    to { 
                        transform: rotateY(0); 
                        opacity: 1;
                    }
                }
            `}</style>

                            <div
                                style={{
                                    backgroundImage: 'url("https://api.weibinyi.com/images/niannian/drifting_bg.png")',
                                    backgroundSize: '100% 100%',
                                    padding: '30px 20px',
                                    borderRadius: '12px',
                                    width: '65%',
                                    textAlign: 'center',
                                    boxShadow: '0 4px 15px rgba(0, 0, 0, 0.3)',
                                    animation: 'cardRotateSlow 1s cubic-bezier(0.34, 1.56, 0.64, 1) forwards',
                                    transformStyle: 'preserve-3d',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                }}
                                onClick={(e) => {
                                    e.stopPropagation();
                                }}
                            >
                                <img
                                    src="https://api.weibinyi.com/images/niannian/4/5-14.png"
                                    alt="祈福灯"
                                    style={{ width: '80px', height: '80px' }}
                                />
                                <h3 style={{ marginBottom: '15px', color: '#8b4513', fontSize: '18px' }}>祈福灯</h3>
                                <p style={{
                                    marginBottom: '20px',
                                    lineHeight: '1.6',
                                    color: '#5d4037',
                                    fontSize: '15px',
                                    flexGrow: 1,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    textAlign: 'center',
                                }}>
                                    {this.state.visibleMsg}
                                </p>
                                <button
                                    style={{
                                        backgroundColor: '#f5f5dc',
                                        border: '1px solid #d2b48c',
                                        color: '#8b4513',
                                        padding: '8px 30px',
                                        borderRadius: '20px',
                                        cursor: 'pointer',
                                        transition: 'all 0.3s ease',
                                        fontSize: '15px',
                                        fontWeight: '500',
                                        boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
                                        marginTop: '10px',
                                    }}
                                    onClick={() => {
                                        this.setState({ visible: false });
                                    }}
                                >
                                    关闭
                </button>
                            </div>
                        </div> : null
                }




            </div>
        )
    }
}

export default withNavigate(Index);